<!--
 * :Date: 2024-07-23 14:13:45
 * :Description: 分页器
 * :Author: zq.wei
 * :LastEditors: zq.wei
 * :LastEditTime: 2024-07-23 14:16:45
-->

<template>
  <div class="pagination-content">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageControl.page"
      :page-sizes="[10, 20, 50, 100, 300, 500]"
      :page-size="pageControl.size"
      layout="total,  prev, pager, next, jumper"
      :total="pageControl.totalElements"
      :disabled="disabled"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    value: {
      type: Object,
      require: true
    },
    getData: {
      type: Function
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageControl: {}
    };
  },
  watch: {
    value: {
      handler(val) {
        this.pageControl = val;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageControl.size = val;
      this.$emit("input", this.pageControl);
      if (this.getData) {
        this.getData();
      }
    },
    handleCurrentChange(val) {
      this.pageControl.page = val;
      this.$emit("input", this.pageControl);
      if (this.getData) {
        this.getData();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.pagination-content {
  margin-top: 3px;
  margin-left: 10px;
  // text-align: right;
}
::v-deep .el-pagination {
  padding: 6px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pager.vue